import React from "react";
import {
    HiCheck,
  // HiOutlineSun,
  // HiOutlineTrash,
  // HiOutlineArrowsExpand,
  // HiLightBulb,
  //   HiPencilAlt,
  HiOutlineX,
} from "react-icons/hi";
import { useTranslation } from "react-i18next";
export default function ApprovZoomPagePartButtons(props) {
  const { t } = useTranslation();
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button is-small modal-button`}
        onClick={props.onClickHandler}
        title={t("Exit")}
      >
        <span className="has-text-success ">{t("Confirm")}</span>
        <span className="icon  has-text-success">
          <HiCheck className="fas fa-2x" />
        </span>
      </button>
    </>
  );
}
